export default class CallbackTokenAccess{
    
    constructor(){
        this.cliente_id = "";
        this.scope = "";
        this.grant_type="";
        this.code = "";
        this.redirect_uri = "";
    }
    
    cliente_id:string;
    scope:string;
    grant_type:string;
    code:string;
    redirect_uri:string;

}


export class Token{
    constructor() {
        this.id_token="";
        this.access_token="";
        this.expires_in= 0;
        this.token_type= "";
        this.refresh_token= "";
        this.scope="";
        this.error=false;
        this.descripcion="";
        this.stack= "";
    };
    id_token:string;
    access_token: string;
    expires_in: number;
    token_type: string;
    refresh_token: string;
    scope:string;
    error:boolean;
    descripcion:string;
    stack: any;
}

export class CadenaParaTokenConCode{
    constructor() {
        this.client_id="";
        this.scope="";
        this.grant_type="";
        this.code=null;
        this.redirect_uri=""
    }
    client_id:string;
    scope:string;
    grant_type:string;
    code: any;
    redirect_uri: string
}


export class ClienteOAuthAutorize{
    constructor() {
        this.client_id="";
        this.scope="";
        this.response_type="";
        this.redirect_uri="";
        this.suscriptor="";
        this.version="";        
    };
    client_id: string;
    scope: string;
    response_type:string;
    redirect_uri: string;
    suscriptor: string;
    version:string;
}